import React from "react";

interface Props {
  title?: string;
  header?: string;
  breadCrumbItems?: BreadCrumbItem[];
}

type BreadCrumbItem = {
  displayText: string;
  link: string;
};

function FoodServiceResourcesHeader({ title, header, breadCrumbItems }: Props) {
  const headerComponent =
    breadCrumbItems?.length === 2 ? (
      <h1 className="page-header">{header}</h1>
    ) : (
      <div className="page-header">{header}</div>
    );

  return (
    <div
      className={`fsr-header mt-0 ${header ? "listing-header" : ""}`}
      data-module="foodServiceResourcesHeader"
    >
      <div className="container vertical-align">
        <div className="header-cover">
          {header ? (
            headerComponent
          ) : (
            <h1 className="page-header">
              <span>Food Service</span>Resources
            </h1>
          )}
        </div>
        <div>
          {title && breadCrumbItems && (
            <span className="fsr-crumbs">
              {breadCrumbItems.map((crumb) => (
                <span key={crumb.displayText}>
                  <a href={crumb.link}>{crumb.displayText}</a>
                  <span> / </span>
                </span>
              ))}
              {title}
            </span>
          )}
        </div>
      </div>
      <div className="header-image clears">
        {header ? (
          <img
            className="pencil"
            src="//cdnimg.webstaurantstore.com/uploads/design/2016/7/fsr-fork-pencil.png"
            alt=""
          />
        ) : (
          <>
            <img
              className="fork"
              src="//cdnimg.webstaurantstore.com/uploads/design/2016/6/fsr-header-fork.png"
              alt=""
            />
            <img
              className="pencil"
              src="//cdnimg.webstaurantstore.com/uploads/design/2016/6/fsr-header-pencil.png"
              alt=""
            />
          </>
        )}
      </div>
    </div>
  );
}

export default FoodServiceResourcesHeader;
